export const HeaderNavigation = () => {
  const SELECTORS = {
    TOGGLE_CLASS: '.has-submenu',
    OPEN_NAV: '.js_open_nav',
    OPEN_SEARCH: '.js_open_search',
    LAST_SUBMENU_ITEM: '.submenuItem.last',
    PRIMARY_NAV_ITEM: '.primary-nav-item',
    SECONDARY_NAV_ITEM: '.secondary-nav-item',
    HEADER_SUBNAV: '.header-subnav',
  };

  const CLASSES = {
    IS_ACTIVE: 'is-active',
    NAV_OPENED: 'nav-opened',
    NAV_SEARCH_OPENED: 'nav-search-opened',
  };

  let elementsWithSubmenus;
  let timer;

  const checkMobile = () => {
    return window.innerWidth < 768;
  };

  const handleNavigationItem = (toggleElement) => {
    // For desktop: hover behavior
    toggleElement.addEventListener('mouseover', () => {
      if (!checkMobile()) {
        clearTimeout(timer);
        clearToggledElements();
        openSubmenu(toggleElement);
      }
    });

    toggleElement.addEventListener('mouseout', () => {
      if (!checkMobile()) {
        timer = setTimeout(() => {
          closeSubmenu(toggleElement);
        }, 100);
      }
    });

    // Add keyboard support - open menu when focus enters
    toggleElement.querySelector('a')?.addEventListener('focus', () => {
      if (!checkMobile()) {
        clearTimeout(timer);
        clearToggledElements();
        openSubmenu(toggleElement);
      }
    });

    // Keep menu open when focus moves inside the submenu
    const submenuItems = toggleElement.querySelectorAll('.submenu a');
    submenuItems.forEach((item) => {
      item.addEventListener('focus', () => {
        if (!checkMobile()) {
          clearTimeout(timer);
        }
      });
    });

    // Optional: close when focus leaves the submenu completely
    const lastSubmenuItem = toggleElement.querySelector(
      '.submenu a:last-child',
    );
    lastSubmenuItem?.addEventListener('blur', (event) => {
      if (!checkMobile() && !toggleElement.contains(event.relatedTarget)) {
        closeSubmenu(toggleElement);
      }
    });

    // For all devices: click behavior (will primarily affect mobile)
    toggleElement.querySelector('a')?.addEventListener('click', (event) => {
      if (checkMobile()) {
        event.preventDefault();
        event.stopPropagation();

        if (toggleElement.classList.contains(CLASSES.IS_ACTIVE)) {
          closeSubmenu(toggleElement);
        } else {
          clearToggledElements();
          openSubmenu(toggleElement);
        }
      }
    });

    // For mobile: close when clicking outside
    document.addEventListener('click', (event) => {
      if (checkMobile() && !toggleElement.contains(event.target)) {
        closeSubmenu(toggleElement);
      }
    });
  };

  const openSubmenu = (toggleElement) => {
    toggleElement.classList.add(CLASSES.IS_ACTIVE);
    toggleElement
      .querySelector(SELECTORS.HEADER_SUBNAV)
      ?.removeAttribute('inert');
    toggleElement.querySelector('a')?.setAttribute('aria-expanded', 'true');
  };

  const closeSubmenu = (toggleElement) => {
    toggleElement.classList.remove(CLASSES.IS_ACTIVE);
    toggleElement
      .querySelector(SELECTORS.HEADER_SUBNAV)
      ?.setAttribute('inert', 'true');
    toggleElement.querySelector('a')?.setAttribute('aria-expanded', 'false');
  };

  const clearToggledElements = () => {
    elementsWithSubmenus.forEach((toggleElement) => {
      toggleElement.classList.remove(CLASSES.IS_ACTIVE);
      toggleElement
        .querySelector(SELECTORS.HEADER_SUBNAV)
        ?.setAttribute('inert', 'true');
    });
  };

  const bindEvents = () => {
    elementsWithSubmenus = document.querySelectorAll(SELECTORS.TOGGLE_CLASS);

    elementsWithSubmenus.forEach((toggleElement) => {
      handleNavigationItem(toggleElement);
    });

    const openNavButton = document.querySelector(SELECTORS.OPEN_NAV);
    openNavButton?.addEventListener('click', () => {
      document.body.classList.remove(CLASSES.NAV_SEARCH_OPENED);
      document.body.classList.toggle(CLASSES.NAV_OPENED);
    });

    const openSearchButton = document.querySelector(SELECTORS.OPEN_SEARCH);
    openSearchButton?.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.remove(CLASSES.NAV_OPENED);
      document.body.classList.toggle(CLASSES.NAV_SEARCH_OPENED);

      if (document.body.classList.contains(CLASSES.NAV_SEARCH_OPENED)) {
        document.dispatchEvent(new CustomEvent('focusSearchInput'));
      }
    });
  };

  const adjustTabOrder = () => {
    const secondaryNavItems = document.querySelectorAll(
      SELECTORS.SECONDARY_NAV_ITEM,
    );

    if (!window.matchMedia('(min-width: 768px)').matches) {
      secondaryNavItems.forEach((item) => {
        item.setAttribute('tabindex', '1');
      });
    }
  };

  const init = () => {
    bindEvents();
    adjustTabOrder();
    window.addEventListener('resize', adjustTabOrder);
  };

  return {
    init,
  };
};

export default HeaderNavigation();
